import { render, staticRenderFns } from "./LicensesSummary.vue?vue&type=template&id=7dc76bbb&scoped=true&"
import script from "./LicensesSummary.vue?vue&type=script&lang=js&"
export * from "./LicensesSummary.vue?vue&type=script&lang=js&"
import style0 from "./LicensesSummary.vue?vue&type=style&index=0&id=7dc76bbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc76bbb",
  null
  
)

export default component.exports